import { ReactComponent as NoCustomerOrdersIcon } from "./svg/iconNoCustomerOrders.svg";
import "./IconNoCustomerOrders.scss";

export const IconNoCustomerOrders = ({ title, className = "" }: { title?: string; className?: string }) => {
  const iconClassName = `icon-no-customer-orders${className ? ` ${className}` : ""}`;
  return <NoCustomerOrdersIcon title={title} className={iconClassName} />;
};
